import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { setAutoplayNext, fetchAutoplayNext } from '../actions';
import { Button as ButtonV2 } from '../v2/components/button/Button';

const AutoNextTrue = React.memo(({ label }) => {
  return (
    <ButtonV2
      icon
      iconType="material"
      label={label}
      materialLabel="check_box"
      size="small"
      type="secondary"
    />
  );
});

const AutoNextFalse = React.memo(({ label }) => {
  return (
    <ButtonV2
      icon
      iconType="material"
      label={label}
      materialLabel="check_box_outline_blank"
      size="small"
      type="secondary"
    />
  );
});

function AutoplayNext({
  strings,
  isAutoNext,
  dataFor,
  setAutoplayNext,
  fetchAutoplayNext,
}) {
  const tooltip = isAutoNext
    ? strings.notAutoplayNextProgramme
    : strings.autoplayNextProgramme;

  const toggleAutoNext = useCallback(() => {
    setAutoplayNext(!isAutoNext);
  }, [isAutoNext, setAutoplayNext]);

  useEffect(() => {
    fetchAutoplayNext();
  }, [fetchAutoplayNext]);

  const AutoplayButton = isAutoNext ? AutoNextTrue : AutoNextFalse;

  return (
    <button
      onClick={toggleAutoNext}
      className="link autoplay-next"
      data-for={dataFor}
      data-tip={tooltip}
    >
        <AutoplayButton label={strings.autoplayNextProgramme} />
        <span className="screen-reader-text">{tooltip}</span>
    </button>
  );
}

function mapStateToProps(state) {
  return {
    isAutoNext: state.autoNext,
  };
}

export default translate(
  connect(mapStateToProps, { setAutoplayNext, fetchAutoplayNext })(AutoplayNext)
);
